// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Fira+Sans:400,500,600,700,800);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}
* {
  box-sizing: border-box;
}
body {
  background: #ffffff !important;
  min-height: 100vh;
  display: flex;
  font-weight: 400;
  font-family: 'Fira Sans', sans-serif;
}
h1,h2,h3,h4,h5,h6,label,span {
  font-weight: 500;
  font-family: 'Fira Sans', sans-serif;
}
body, html, .App, #root, .auth-wrapper {
  width: 100%;
  height: 100%;
}
.navbar-light {
  background-color: #ffffff;
  box-shadow: 0px 14px 80px rgba(34, 35, 58, 0.2);
}
.auth-wrapper {
  display: flex;
  justify-content: center;
  flex-direction: column;
  text-align: left;
}
.auth-inner {
  width: 450px;
  margin: auto;
  background: #ffffff;
  box-shadow: 0px 14px 80px rgba(34, 35, 58, 0.2);
  padding: 40px 55px 45px 55px;
  border-radius: 15px;
  transition: all .3s;
}
.auth-wrapper .form-control:focus {
  border-color: #167bff;
  box-shadow: none;
}
.auth-wrapper h3 {
  text-align: center;
  margin: 0;
  line-height: 1;
  padding-bottom: 20px;
}
.custom-control-label {
  font-weight: 400;
}
.forgot-password,
.forgot-password a {
  text-align: right;
  font-size: 13px;
  padding-top: 10px;
  color: #7f7d7d;
  margin: 0;
}
.forgot-password a {
  color: #167bff;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE;aACW;AACb;AAGA;EACE,sBAAsB;AACxB;AACA;EACE,8BAA8B;EAC9B,iBAAiB;EACjB,aAAa;EACb,gBAAgB;EAChB,oCAAoC;AACtC;AACA;EACE,gBAAgB;EAChB,oCAAoC;AACtC;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,yBAAyB;EACzB,+CAA+C;AACjD;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,sBAAsB;EACtB,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,+CAA+C;EAC/C,4BAA4B;EAC5B,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,cAAc;EACd,oBAAoB;AACtB;AACA;EACE,gBAAgB;AAClB;AACA;;EAEE,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,SAAS;AACX;AACA;EACE,cAAc;AAChB","sourcesContent":["body {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\n\n@import url('https://fonts.googleapis.com/css?family=Fira+Sans:400,500,600,700,800');\n* {\n  box-sizing: border-box;\n}\nbody {\n  background: #ffffff !important;\n  min-height: 100vh;\n  display: flex;\n  font-weight: 400;\n  font-family: 'Fira Sans', sans-serif;\n}\nh1,h2,h3,h4,h5,h6,label,span {\n  font-weight: 500;\n  font-family: 'Fira Sans', sans-serif;\n}\nbody, html, .App, #root, .auth-wrapper {\n  width: 100%;\n  height: 100%;\n}\n.navbar-light {\n  background-color: #ffffff;\n  box-shadow: 0px 14px 80px rgba(34, 35, 58, 0.2);\n}\n.auth-wrapper {\n  display: flex;\n  justify-content: center;\n  flex-direction: column;\n  text-align: left;\n}\n.auth-inner {\n  width: 450px;\n  margin: auto;\n  background: #ffffff;\n  box-shadow: 0px 14px 80px rgba(34, 35, 58, 0.2);\n  padding: 40px 55px 45px 55px;\n  border-radius: 15px;\n  transition: all .3s;\n}\n.auth-wrapper .form-control:focus {\n  border-color: #167bff;\n  box-shadow: none;\n}\n.auth-wrapper h3 {\n  text-align: center;\n  margin: 0;\n  line-height: 1;\n  padding-bottom: 20px;\n}\n.custom-control-label {\n  font-weight: 400;\n}\n.forgot-password,\n.forgot-password a {\n  text-align: right;\n  font-size: 13px;\n  padding-top: 10px;\n  color: #7f7d7d;\n  margin: 0;\n}\n.forgot-password a {\n  color: #167bff;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
